<div id="solar-receiver">
  <p-select [options]="solarReceiverType" [(ngModel)]="selectedSolarReceiverType"
    (onChange)="doSelectRecieverType($event)" [style]="{width:'300px', 'margin-bottom': '24px'}"></p-select>

  <p-selectButton [options]="waterHeating" [(ngModel)]="waterHeatingSelected"
    (onChange)="onFindSelectedClicked($event)">
  </p-selectButton>

  <div *ngIf="waterHeatingSelected === 1" class="form-container">
    <!-- <form [formGroup]="remotePowerForm" (ngSubmit)="submitForm()"> -->
    <div class="form">
      <div class="wrapper2">
        <div>
          <h5>Tip sončnih sprejemnikov</h5>

          <label class="container">
          <p-select
            [options]="solarRoofType"
            [(ngModel)]="solarRoofTypeSelected"
            (onChange)="doSelectRecieverType($event)"
            [style]="{ width: '300px' }"
            appendTo="body">
          </p-select>
          </label>
        </div>
        <div>
          <h5>Iskanje po naslovu</h5>
          <label class="container">
            <app-search (onselect)="onSearchSelect($event)"></app-search>
            <!-- <input type="text" class="consumption-value" placeholder="Iskanje po naslovu..."> -->
          </label>
        </div>
      </div>

      <button class="button" (click)="onAddressSubmit()" >Analiza</button>
    </div>
  </div>
  <div *ngIf="waterHeatingSelected === 2" class="form-container">

    <form  class="form" [formGroup]="powerPlantRoofObjectSrchForm" (ngSubmit)="onSubmitPPORS()">
      <div class="wrapper2">
        <div>
          <h5>Prevladujoča raba objekta</h5>
          <p-select [options]="rabeobjekta" [(ngModel)]="selectedraba" formControlName="raba">
          </p-select>
        </div>
        <div>
          <h5>Delež pokritosti rabe STV s sončnimi sprejemniki <span style="float: right;">[%]</span></h5>
          <div class="container">
            <input formControlName="coveredSTV" type="range" min="0" max="100" id="myRange"
            class="consumption-value slider-value">
            <p class="placeholder"><span>{{ powerPlantRoofObjectSrchForm.get('coveredSTV').value }}</span>%</p>
          </div>
         
        </div>
      </div>
      <div class="wrapper2">
        <div>
          <h5>Lastništvo objekta</h5>
          <label class="container">Država <input type="checkbox" formControlName="lastnik_drzava"> <span
              class="checkmark"></span></label>
          <label class="container">Občina <input type="checkbox" formControlName="lastnik_obcina"> <span
              class="checkmark"></span></label>
          <label class="container">Pravna oseba<input type="checkbox" formControlName="lastnik_pravna_os"> <span
              class="checkmark"></span></label>
          <label class="container">Fizična oseba<input type="checkbox" formControlName="lastnik_fizicna_os"> <span
              class="checkmark"></span></label>
        </div>
        <div>
          <h5>Tip sončnih sprejemnikov</h5>
          <p-select [options]="solarRoofType" formControlName="roof_type" [(ngModel)]="solarRoofTypeSelected"
            (onChange)="doSelRoofType($event)"></p-select>
          <!-- <label class="container">Samo ravne strehe <input type="checkbox" formControlName="ravna_s">
            <span class="checkmark"></span></label> -->
        </div>
      </div>


      <div class="wrapper2">
        <div>
          <h5>Kulturna dediščina</h5>
          <label class="container">Objekt ni spomeniško zaščiten <input type="checkbox" formControlName="brez_kult_ded">
            <span class="checkmark"></span></label>
        </div>
        <div>
          <h5>Starost strehe in objekta</h5>
          <label class="inputcontainer">Najdaljši čas od zadnje obnove strehe (v letih)<input type="number" min="0"
              align="right" formControlName="l_ob_str"></label>
          <label class="inputcontainer">Največja starost objekta (v letih)<input type="number" min="0" align="right"
              formControlName="l_ob_obj"></label>
        </div>
      </div>
      <div class="wrapper2">
        <div>
          <h5>Maksimalno število objektov v rezultatu</h5>
          <label class="inputcontainer">Število ustreznih objektov (0 pomeni vsi)<input type="number" align="right"
              formControlName="max_rs_obj"></label>
        </div>
        <div></div>
      </div>
      <button class="button" type="submit">Analiza</button>
    </form>
  </div>

</div>